export const LOGIN_TOKEN = 'login_token'
export const ENTRANCE_ID = 'entrance_id'
export const CODE_LIST = 'code_list'
